<div>
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a routerLink="/locations">Locations</a></li>
    <li class="breadcrumb-item active">{{locationCollection.name}}</li>
  </ol>
  <h1>{{locationCollection.name}}</h1>
  @if (!isEdit) {
    <div>
      <table class="table table-striped">
        <tbody>
          <tr>
            <th>Name</th>
            <td>{{locationCollection.name}}</td>
          </tr>
          <tr>
            <th>Created On</th>
            <td>{{locationCollection.created_on}}</td>
          </tr>
          <tr>
            <th>Updated On</th>
            <td>{{locationCollection.updated_on}}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-left">
        <button class="btn btn-primary" (click)="toggleEdit()">Edit</button>
      </div>
    </div>
  }
  @if (isEdit) {
    <div>
      <form class="form-horizontal col col-sm-6" >
        <table class="table table-striped">
          <tbody>
            <tr>
              <th>Group Name</th>
              <td>
                <input type="text"
                  class="form-control"
                  name="name"
                  [(ngModel)]="locationCollection.name"
                  placeholder="Name">
              </td>
            </tr>
            <tr>
              <th>Created On</th>
              <td>{{locationCollection.created_on}}</td>
            </tr>
            <tr>
              <th>Updated On</th>
              <td>{{locationCollection.updated_on}}</td>
            </tr>
          </tbody>
        </table>
        <div class="action-wrap text-left">
          <button type="button" class="btn btn-danger" (click)="delete()">Delete</button>
          <button type="button" class="btn btn-primary pull-right" (click)="update()">Save Changes</button>
          <button type="button" class="btn btn-default pull-right" (click)="toggleEdit()">Close</button>
        </div>
      </form>
    </div>
  }
</div>
